module.exports = __webpack_public_path__ + "img/sintesis.5cef0fc5.svg";